import { Route } from '@angular/router';
import { FhSettingsGenericComponent } from './components/fh-settings-generic.component';

export const fhSettingsGenericRoutes: Route[] = [
  { path: '', pathMatch: 'full', component: FhSettingsGenericComponent },
  {
    path: 'general',
    component: FhSettingsGenericComponent,
    data: {
      title: 'shared.settings.pages.general.title',
      description: 'shared.settings.pages.general.description',
      feature: 'settings-general',
      formName: 'generalSettings',
      fhSideBarConfigs: {
        widthChangedEmitter: '330px',
        configHeaderEmitter: {
          navigateBackButton: true,
          outlet: 'user-data',
          parentNavigation: 'menu/settings',
          parentLabel: 'shared.settings.title'
        }
      },
      uiList: [
        {
          name: 'pageHeader'
        },
        {
          name: 'form',
          formItems: [
            {
              type: 'dropdown',
              label: 'generics.default_language',
              formControl: 'defaultLanguage',
              placeHolder: 'generics.languages.title',
              dropDownOptions: []
            },
            {
              type: 'dropdown',
              label: 'generics.default_menu',
              formControl: 'expandedMenu',
              defaultValue: 'automatic',
              dropDownOptions: [
                {
                  value: 'automatic',
                  label: 'generics.automatic'
                },
                {
                  value: 'true',
                  label: 'generics.expanded'
                },
                {
                  value: 'false',
                  label: 'generics.collapsed'
                }
              ]
            },
            {
              type: 'switch',
              label: 'generics.nightMode',
              formControl: 'nightMode',
              dividerLabel: 'shared.settings.dividers.visual'
            }
          ]
        }
      ]
    }
  },
  {
    path: 'homepage',
    component: FhSettingsGenericComponent,
    data: {
      title: 'shared.settings.pages.homepage.title',
      description: 'shared.settings.pages.homepage.description',
      feature: 'settings-homepage',
      formName: 'homepageSettings',
      fhSideBarConfigs: {
        widthChangedEmitter: '330px',
        configHeaderEmitter: {
          navigateBackButton: true,
          outlet: 'user-data',
          parentNavigation: 'menu/settings',
          parentLabel: 'shared.settings.title'
        }
      },
      uiList: [
        {
          name: 'pageHeader'
        },
        {
          name: 'form',
          formItems: [
            {
              type: 'dropdown',
              label: 'generics.active-wallet-position',
              formControl: 'activeWallet',
              defaultValue: 'horizontal',
              dropDownOptions: [
                {
                  value: 'horizontal',
                  label: 'generics.horizontal'
                },
                {
                  value: 'vertical',
                  label: 'generics.vertical'
                }
              ]
            }
          ]
        }
      ]
    }
  },
  {
    path: 'accessibility',
    component: FhSettingsGenericComponent,
    data: {
      title: 'shared.settings.pages.accessibility.title',
      description: 'shared.settings.pages.accessibility.description',
      feature: 'settings-accessibility',
      formName: 'accessibilitySettings',
      fhSideBarConfigs: {
        widthChangedEmitter: '330px',
        configHeaderEmitter: {
          navigateBackButton: true,
          outlet: 'user-data',
          parentNavigation: 'menu/settings',
          parentLabel: 'shared.settings.title'
        }
      },
      uiList: [
        {
          name: 'pageHeader'
        },
        {
          name: 'form',
          formItems: [
            {
              type: 'switch',
              label: 'generics.dyslexic-font',
              formControl: 'dyslexicFont',
              dividerLabel: 'shared.settings.dividers.fonts',
              defaultValue: false
            },
            {
              type: 'dropdown',
              label: 'generics.font-size',
              formControl: 'textSize',
              defaultValue: 'medium',
              dropDownOptions: [
                {
                  value: 'small',
                  label: 'generics.textSize.small'
                },
                {
                  value: 'medium',
                  label: 'generics.textSize.medium'
                },
                {
                  value: 'large',
                  label: 'generics.textSize.large'
                }
              ]
            },
            {
              type: 'switch',
              dividerLabel: 'shared.settings.dividers.general-visibility',
              label: 'generics.zoom-accessibility',
              formControl: 'zoomAccessibility'
            },
            {
              type: 'switch',
              label: 'generics.colorBlind-disable',
              formControl: 'colorsDisable',
            },
            {
              type: 'switch',
              label: 'generics.animations-disable',
              formControl: 'animationsDisable'
            }
          ]
        }
      ]
    }
  }
];
